import S from './AttendeeEvents.module.scss';
import { Avatar } from 'primereact/avatar';
import { Text } from 'src/redesign/components/Text';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { accountSelector } from 'src/redesign/features/Account/store/selectors';
import { generateRandomGradient } from 'src/redesign/shared/utils/getRandomLinearGradient';
import { EventCard } from 'src/redesign/features/AttendeeEvents/components/EventCard';
import { FlagIcon, PastIconWithArrow } from 'src/redesign/assets/icons';
import { useEffect } from 'react';
import { fetchAttendeeTickets } from 'src/redesign/features/Attendees/store/actions';
import {
  attendeeTicketsLoadingSelector,
  attendeeTicketsSelector,
} from 'src/redesign/features/Attendees/store/selectors';
import { Loader } from 'wix-style-react';

export const AttendeeEvents = () => {
  const account = useAppSelector(accountSelector);
  const attendeeTickets = useAppSelector(attendeeTicketsSelector);
  const isLoading = useAppSelector(attendeeTicketsLoadingSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchAttendeeTickets());
  }, [dispatch]);

  // Separate upcoming and past events
  const upcomingEvents =
    attendeeTickets?.filter((ticket) => new Date(ticket.event.end_date) >= new Date()) || [];

  const pastEvents =
    attendeeTickets?.filter((ticket) => new Date(ticket.event.end_date) < new Date()) || [];

  return (
    <section className={S.attendeeEvents}>
      <div className={S.accountSection}>
        <Avatar
          className={S.avatar}
          style={{
            background: generateRandomGradient(),
          }}
          shape="circle"
          template={() => (
            <Text variation="h4" bold color="white-100">
              {account?.first_name?.charAt(0) || 'U'}
            </Text>
          )}
        />
        <div className={S.accountInfo}>
          <Text variation="h2" bold>
            {account?.first_name} {account?.last_name}
          </Text>
          <Text variation="body-small" color="black-100">
            {account?.email}
          </Text>
        </div>
      </div>

      {isLoading ? (
        <Text variation="h4" style={{ textAlign: 'center', marginTop: '2rem' }}>
          <Loader size="small" />
        </Text>
      ) : (
        <div className={S.eventsLayout}>
          {upcomingEvents.length > 0 && (
            <div className={S.eventSection}>
              <div className={S.eventsSectionTitleContainer}>
                <FlagIcon />
                <Text className={S.eventsSectionTitle} variation="h4">
                  Upcoming Events
                </Text>
              </div>
              <div className={S.events}>
                {upcomingEvents.map((ticket) => (
                  <EventCard key={ticket.cart_id} ticketInfo={ticket} />
                ))}
              </div>
            </div>
          )}

          {pastEvents.length > 0 && (
            <div className={S.eventSection}>
              <div className={S.eventsSectionTitleContainer}>
                <PastIconWithArrow />
                <Text className={S.eventsSectionTitle} variation="h4">
                  Past Events
                </Text>
              </div>
              <div className={S.events}>
                {pastEvents.map((ticket) => (
                  <EventCard key={ticket.cart_id} ticketInfo={ticket} />
                ))}
              </div>
            </div>
          )}

          {!isLoading && upcomingEvents.length === 0 && pastEvents.length === 0 && (
            <Text variation="h4" style={{ textAlign: 'center', marginTop: '2rem' }}>
              You don't have any tickets yet
            </Text>
          )}
        </div>
      )}
    </section>
  );
};
